import { render, staticRenderFns } from "./ShopDeliver.vue?vue&type=template&id=bd6bacb8&scoped=true"
import script from "./ShopDeliver.vue?vue&type=script&lang=js"
export * from "./ShopDeliver.vue?vue&type=script&lang=js"
import style0 from "./ShopDeliver.vue?vue&type=style&index=0&id=bd6bacb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6bacb8",
  null
  
)

export default component.exports